//have to be the same as in backend
export const NORMAL_TYPE = 0;
export const HOME_TYPE = 1;
export const WORK_TYPE = 2;
export const OTHER_TYPE = 3;
